<template>
    <div class="course__show">
        <div class="course__show_header">
            <div class="container">
                <div class="columns is-block-mobile is-variable is-4">
                    <div class="column is-6-tablet is-7-widescreen">
                        <div class="course__show_header_details">
                            <div class="columns">
                                <div class="column">
                                    <view-actions
                                        :title="`Course: ${courseName}`"
                                        :notify-title="'course'"
                                        :notify-process="'stop showing'"
                                        :switcher-active="false"
                                        :switcher-value="true"
                                        :switcher-disabled="true"
                                        :cancel-button-active="false"
                                        :submit-button-active="(user.isCourseCreator() || (user.isLearningExperienceAdministrator() && routeQueryView === 'admin')) && routeIsCourseView"
                                        :submit-button-text="routeQueryView === 'admin' && routeQueryCourseVersionId ? 'Edit course' : (courseIsDraftVersion ? 'Edit draft' : 'Edit course')"
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: 'Courses',
                                                to: { name: 'ebs-course-list' }
                                            }
                                        ]"
                                        :size="'small'"
                                        @emit-cancel="courseStopShow"
                                        @emit-submit="handleRedirection"
                                    />
                                    <pop-notify
                                        :class="'pop__notify--cancel'"
                                        ref="notifyrequestenrolment"
                                        :title-text="'Request enrolment'"
                                        :content-text="'A request will be sent to an administrator to allow your enrolment. Once administrator has either approved or rejected your request you will be notified. If your request is approved you will be enrolled onto the course, however, if your request is rejected you will not be enrolled onto this course.'"
                                        :cancel-button-text="'Cancel'"
                                        :submit-button-text="'Send request'"
                                        :prevent-close="true"
                                        :submit-button-animate-loading="true"
                                        :submit-button-animate-loading-name="'course-enroll'"
                                        @emit-submit="performEnrolment"
                                    />
                                </div>
                            </div>
                            <div class="columns">
                                <template v-if="courseDescription">
                                    <div class="column">
                                        <div class="course__show_header_details_description">
                                            <component-text
                                                :html="true"
                                                :read-more-active="true"
                                                :read-more-limit="courseImages.length ? 425 : 600"
                                            >{{ courseDescription }}
                                            </component-text>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <template v-if="courseImages.length">
                        <div class="column is-6-tablet is-5-widescreen">
                            <div class="course__show_header_image">
                                <component-slider
                                    :images="courseImages"
                                    :alt="courseName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="course__show_main">
            <div class="container">
                <div class="columns is-block-mobile">
                    <div class="column is-6-tablet is-5-desktop is-4-widescreen is-3-fullhd course__show_main--columnsecondary">
                        <div class="course__show_main_secondary">
                            <template v-if="allowForEnrolmentButton && !isUserEnrolled">
                                <div class="course__show_main_secondary_actions">
                                    <component-button
                                        :align="'left'"
                                        :name="'course-show-main-secondary-actions-enrol'"
                                        :animate-loading="!catalogItemHasRequiredApproval"
                                        :animate-loading-event-name="'course-enroll'"
                                        :theme="isUserEnrolled || learnerLatestCompletion || learnerLatestFail ? 'default' : 'primary'"
                                        @click="handleEnrolment"
                                    >{{ enrolButtonText }}
                                    </component-button>
                                </div>
                            </template>
                            <template v-if="routeIsCourseVersionView || routeIsCourseEnrolmentView">
                                <template v-if="isUserEnrolled || learnerLatestCompletion">
                                    <div :class="[
                                        'course__show_main_secondary_progressbar',
                                        learnerLatestCompletion && courseCompletionPercentage === 100 ? 'course__show_main_secondary_progressbar--completed' : ''
                                    ]">
                                        <template v-if="isUserEnrolled && courseCatalogItemUserEnrolmentId && routeParamsEnrolmentId && (courseCatalogItemUserEnrolmentId !== routeParamsEnrolmentId)">
                                            <div class="course__show_main_secondary_progressbar_hascurrentenrolment">
                                                <component-text>You are currently enrolled on this course.</component-text>
                                                <component-button
                                                    :name="'course-show-main-sceondary-progressbar-hascurrentenrolment-link'"
                                                    :text="true"
                                                    :to="{ name: 'ebs-course-enrolment-show', params: { courseId: courseId, versionId: catalogItemVersionId, courseCatalogId: catalogItemId, enrolmentId: courseCatalogItemUserEnrolmentId } }"
                                                >Take me to my enrolment</component-button>
                                            </div>
                                        </template>
                                        <template v-if="courseHistoryRequestCompleted && enrolmentRequestCompleted">
                                            <component-title
                                                :class="'course__show_main_secondary_progressbar_title'"
                                                :size="'small'"
                                                :raw="true"
                                            >Progress
                                            </component-title>
                                            <component-progress-bar
                                                :title="''"
                                                :stage="''"
                                                :progress="courseCompletionPercentage"
                                            >
                                                <template v-slot:right>
                                                    <template v-if="isUserEnrolled">
                                                        <component-title
                                                            :raw="true"
                                                            :size="'small'"
                                                        >{{ courseNodesCompleted.length }}/{{ courseNodes.length }}
                                                        </component-title>
                                                    </template>
                                                    <template v-else>
                                                        <v-icon name="check-circle"></v-icon>
                                                    </template>
                                                </template>
                                            </component-progress-bar>
                                            <template v-if="learnerLatestCompletion || learnerEnrolmentById">
                                                <div class="course__show_main_secondary_completion">
                                                    <div class="columns">
                                                        <div class="column">
                                                            <component-title
                                                                :class="'course__show_main_secondary_completion_title'"
                                                                :size="'small'"
                                                                :raw="true"
                                                            >{{ routeIsCourseEnrolmentView ? 'Completion date' : 'Last completion date' }}
                                                            </component-title>
                                                            <component-text
                                                                :class="'course__show_main_secondary_completion_date'"
                                                            >{{ routeIsCourseEnrolmentView ? learnerEnrolmentByIdDate : learnerLatestCompletionDate }}
                                                            </component-text>
                                                        </div>
                                                        <div class="column is-narrow">
                                                            <component-button
                                                                :name="`course-show-main-secondary-completion-certificate`"
                                                                :theme="'default'"
                                                                :icon="true"
                                                                :icon-name="'award'"
                                                                :to-external="routeIsCourseEnrolmentView ? learnerEnrolmentCertificateUrl : learnerLatestCompletionCertificateUrl"
                                                                :target="true"
                                                            ></component-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <component-loading></component-loading>
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-if="outputFiles.length || outputUrls.length">
                                <div class="course__show_main_secondary_extra">
                                    <template v-if="outputFiles.length">
                                        <div class="course__show_main_secondary_extra_item course__show_main_secondary_extra_item--files">
                                            <course-show-attachments
                                                :files="outputFiles"
                                            ></course-show-attachments>
                                        </div>
                                    </template>
                                    <template v-if="routeIsCourseView ? courseUrls.length : catalogItemUrls.length">
                                        <div class="course__show_main_secondary_extra_item course__show_main_secondary_extra_item--urls">
                                            <course-show-links
                                                :links="routeIsCourseView ? courseUrls : catalogItemUrls"
                                                :allow-display="isUserEnrolled || routeIsCourseView && user.isCourseCreator()"
                                            ></course-show-links>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="column is-6-tablet is-7-desktop is-8-widescreen is-9-fullhd course__show_main--columnprimary">
                        <div class="course__show_main_primary">
                            <course-show-tabs></course-show-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="notifycancelenrolment"
            :title-text="hasUserEnrolmentRequest ? 'Cancel enrolment request' : 'Unenrol'"
            :content-text="`Are you sure you want to cancel ${ hasUserEnrolmentRequest ? 'enrolment request' : 'enrolment' }?`"
            :cancel-button-text="'Dismiss'"
            :submit-button-text="'Confirm'"
            :submit-button-danger="true"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'course-enroll'"
            :prevent-close="true"
            @emit-submit="performCancelEnrolment"
        ></pop-notify>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import ComponentText from '@/components/default/shared/ComponentText'
import { toISODate, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentSlider from '@/components/default/shared/ComponentSlider'
import ComponentButton from '@/components/default/shared/ComponentButton'
import CourseShowTabs from '@/components/ebs/courses/show/CourseShowTabs'
import PopNotify from '@/components/default/shared/PopNotify'
import CourseShowAttachments from '@/components/ebs/courses/show/CourseShowAttachments'
import CourseShowLinks from '@/components/ebs/courses/show/CourseShowLinks'
import ComponentProgressBar from '@/components/default/shared/ComponentProgressBar'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'course-show',
  components: { ComponentLoading, ComponentTitle, ComponentProgressBar, ComponentButton, CourseShowLinks, CourseShowAttachments, PopNotify, CourseShowTabs, ComponentSlider, ComponentText, ViewActions },
  data () {
    return {
      user: new User(),
      ComponentButton,
      courseHistoryRequestCompleted: false,
      enrolmentRequestCompleted: false
    }
  },
  computed: {
    routeIsCourseView () {
      return this.$route.name === 'ebs-course-show'
    },
    routeIsCourseVersionView () {
      return this.$route.name === 'ebs-course-version-show'
    },
    routeIsCourseEnrolmentView () {
      return this.$route.name === 'ebs-course-enrolment-show'
    },
    routeParamsEnrolmentId () {
      return this.$route.params.enrolmentId
    },
    routeParamsCourseId () {
      return this.$route.params.courseId
    },
    routeParamsVersionId () {
      return this.$route.params.versionId
    },
    routeParamsCourseCatalogId () {
      return this.$route.params.courseCatalogId
    },
    catalogItemFiles () {
      return this.$store.getters.getEbsCatalogItemFiles
    },
    catalogItemVersionId () {
      return this.$store.getters.getEbsCatalogItemVersionId
    },
    courseFiles () {
      return this.$store.getters.getEbsCourseFiles
    },
    outputFiles () {
      return this.routeIsCourseView ? this.courseFiles : this.catalogItemFiles
    },
    catalogItemUrls () {
      return this.$store.getters.getEbsCatalogItemUrls
    },
    courseUrls () {
      return this.$store.getters.getEbsCourseUrls
    },
    outputUrls () {
      return this.routeIsCourseView ? this.courseUrls : this.catalogItemUrls
    },
    catalogItemId () {
      return this.$store.getters.getEbsCatalogItemId
    },
    courseName () {
      return this.$store.getters.getEbsCourseName
    },
    courseDescription () {
      return this.$store.getters.getEbsCourseDescription
    },
    courseId () {
      return this.$store.getters.getEbsCourseId
    },
    courseNodes () {
      return this.$store.getters.getEbsCourseCompletionNodes
    },
    courseNodesCompleted () {
      return this.$store.getters.getEbsCourseCompletionNodesCompleted
    },
    courseImages () {
      return this.$store.getters.getEbsCourseFile.map(image => {
        return image.imageId
      })
    },
    courseIsDraftVersion () {
      return this.$store.getters.getEbsCourseIsDraftVersion
    },
    courseLatestVersionNumber () {
      return this.$store.getters.getEbsCourseLatestVersionNumber
    },
    courseLatestVersionDate () {
      const latestVersionDate = this.$store.getters.getEbsCourseLatestVersionDate
      return toLocaleDateTime(latestVersionDate) + ' ' + toLocaleTime(latestVersionDate)
    },
    courseCatalogItemLatestEnrolment () {
      return this.$store.getters.getEbsCatalogItemLatestEnrolment
    },
    courseCatalogItemUserEnrolmentId () {
      return this.$store.getters.getEbsCatalogItemLatestEnrolmentId
    },
    courseCatalogItemUserEnrolmentState () {
      return this.$store.getters.getEbsCatalogItemLatestEnrolmentState
    },
    courseCompletionPercentage () {
      return this.$store.getters.getEbsCourseCompletionPercentage
    },
    allowForEnrolmentButton () {
      return (
        (
          this.routeIsCourseVersionView ||
      this.routeIsCourseEnrolmentView
        ) &&
      this.user.isLearner()
      )
    },
    catalogItemHasRequiredApproval () {
      return this.$store.getters.getEbsCatalogItemRequireApproval
    },
    isCancelEnrolmentAllowed () {
      return this.$store.getters.getEbsEnrolmentIsCancelEnrolmentAllowed
    },
    isUserEnrolled () {
      return this.$store.getters.getEbsEnrolmentIsUserEnrolled
    },
    hasUserEnrolmentRequest () {
      return this.$store.getters.getEbsEnrolmentHasUserEnrolmentRequest
    },
    enrolButtonText () {
      let textStr
      if (this.isUserEnrolled) {
        textStr = 'Enrolled'
      } else if (this.hasUserEnrolmentRequest) {
        textStr = 'Cancel enrolment request'
      } else {
        if (this.learnerLatestCompletion || this.learnerLatestFail) {
          textStr = this.catalogItemHasRequiredApproval ? 'Request re-enrolment' : 'Re-enrol'
        } else {
          textStr = this.catalogItemHasRequiredApproval ? 'Request enrolment' : 'Enrol'
        }
      }

      return textStr
    },
    routeQueryView () {
      return this.$route.query.view
    },
    routeQueryCourseVersionId () {
      return this.$route.query.courseVersionId
    },
    routeQueryCatalogId () {
      return this.$route.query.catalogId
    },
    learnerLatestFail () {
      return this.$store.getters.getEbsCatalogItemLearnerEnrolmentsLatestFail
    },
    learnerEnrolmentById () {
      const routeEnrolmentId = this.$route.params.enrolmentId

      return this.$store.getters.getEbsCatalogItemLearnerEnrolmentsById(routeEnrolmentId)
    },
    learnerEnrolmentByIdDate () {
      const latestCompletion = this.learnerEnrolmentById
      const historyEntry = latestCompletion ? latestCompletion.history.find(obj => obj.state === 'completed') : null
      return historyEntry ? toISODate(historyEntry.createdAt).replaceAll('-', '/') : null
    },
    learnerEnrolmentCertificateUrl () {
      return this.learnerEnrolmentById ? this.learnerEnrolmentById.certificateUrl : null
    },
    learnerLatestCompletion () {
      return this.$store.getters.getEbsCatalogItemLearnerEnrolmentsLatestCompletion
    },
    learnerLatestCompletionCertificateUrl () {
      return this.learnerLatestCompletion ? this.learnerLatestCompletion.certificateUrl : null
    },
    learnerLatestCompletionDate () {
      const latestCompletion = this.learnerLatestCompletion
      const historyEntry = latestCompletion ? latestCompletion.history.find(obj => obj.state === 'completed') : null
      return historyEntry ? toISODate(historyEntry.createdAt).replaceAll('-', '/') : null
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('course-submit')
    },
    //
    courseStopShow () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-course-list' })
    },
    redirectToCreateNewVersion () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-course-edit', params: { id: this.courseId }, query: { type: 'new-version' } })
    },
    redirectToEditDraft () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-course-edit', params: { id: this.courseId }, query: { type: 'edit-draft' } })
    },
    redirectToEditCatalogItem () {
      this.$router.push({ name: 'ebs-catalog-item-edit-enrolment', params: { courseId: this.courseId, versionId: this.routeQueryCourseVersionId, catalogId: this.routeQueryCatalogId } })
    },
    performEnrolment () {
      this.$store.dispatch('ebsEnrolmentCreate', this.catalogItemId).then(() => {
        this.$eventBus.$emit('perform-get-course')
        if (this.catalogItemHasRequiredApproval) {
          this.closeNotifyRequestEnrolment()
        }
      }).finally(() => {
        this.$eventBus.$emit('stop-course-enroll')
      })
    },
    performRequestEnrolment () {
      this.$store.dispatch('ebsEnrolmentCreateRequest', this.catalogItemId).then(() => {
        this.$eventBus.$emit('perform-get-course')
      }).finally(() => {
        this.$eventBus.$emit('stop-course-request-enroll')
      })
    },
    performCancelEnrolment () {
      this.$store.dispatch('ebsEnrolmentCancel', this.courseCatalogItemUserEnrolmentId).then(() => {
        this.closeNotifyCancelEnrolment()
        this.$eventBus.$emit('perform-get-course')
      }).finally(() => {
        this.$eventBus.$emit('stop-course-enroll')
      })
    },
    openNotifyRequestEnrolment () {
      this.$refs.notifyrequestenrolment.openNotify()
    },
    closeNotifyRequestEnrolment () {
      this.$refs.notifyrequestenrolment.closeNotify()
    },
    openNotifyCancelEnrolment () {
      this.$refs.notifycancelenrolment.openNotify()
    },
    closeNotifyCancelEnrolment () {
      this.$refs.notifycancelenrolment.closeNotify()
    },
    handleEnrolment () {
      if (this.isUserEnrolled || this.hasUserEnrolmentRequest) {
        this.openNotifyCancelEnrolment()
      } else {
        if (this.catalogItemHasRequiredApproval) {
          this.openNotifyRequestEnrolment()
        } else {
          this.performEnrolment()
        }
      }
    },
    handleRedirection () {
      if (this.routeQueryView === 'admin') {
        this.redirectToEditCatalogItem()
      } else if (this.courseIsDraftVersion) {
        this.redirectToEditDraft()
      } else {
        this.redirectToCreateNewVersion()
      }
    }
  },
  created () {
    this.$eventBus.$on('ebs-course-get-history', () => this.courseHistoryRequestCompleted = true)
    this.$eventBus.$on('ebs-enrolment-get', () => this.enrolmentRequestCompleted = true)
  },
  beforeDestroy () {
    this.$eventBus.$off('ebs-course-get-history')
    this.$eventBus.$off('ebs-enrolment-get')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseshow";
</style>
